package com.patronat.top.client.presentation.map

import com.patronat.top.client.location.ClientGeoLocation
import com.patronat.top.core.base.ViewEvent
import com.patronat.top.core.base.ViewSideEffect
import com.patronat.top.core.base.ViewState
import com.patronat.top.dto.VenueResponse
import com.patronat.top.dto.venues.VenueGroup

data class ClientMapViewState(
    val isLoading: Boolean = false,
    val searchQuery: String = "",
    val venues: List<VenueResponse> = emptyList(),
    val markers: List<ClientMapMarker> = emptyList(),
    val selectedVenueId: String? = null,
    val userLocation: ClientGeoLocation? = null,
    val isListExpanded: Boolean = false,
    val cameraTarget: ClientMapCameraTarget = ClientMapCameraTarget(
        latitude = DefaultMapLatitude,
        longitude = DefaultMapLongitude,
        zoom = DefaultMapZoom
    ),
    val mapErrorMessage: String? = null
) : ViewState {
    val selectedVenue: VenueResponse?
        get() = selectedVenueId?.let { id -> venues.firstOrNull { it.id == id } }
}

data class ClientMapMarker(
    val venueId: String,
    val title: String,
    val group: VenueGroup,
    val latitude: Double,
    val longitude: Double
)

data class ClientMapCameraTarget(
    val latitude: Double,
    val longitude: Double,
    val zoom: Double
)

sealed interface ClientMapEvent : ViewEvent {
    data object OnRefresh : ClientMapEvent
    data class OnSearchChanged(val value: String) : ClientMapEvent
    data class OnMarkerClicked(val venueId: String) : ClientMapEvent
    data object OnMapClicked : ClientMapEvent
    data object OnToggleListClicked : ClientMapEvent
    data class OnMapLoadFailed(val reason: String?) : ClientMapEvent
    data object OnMapLoadFinished : ClientMapEvent
}

sealed interface ClientMapEffect : ViewSideEffect

internal const val DefaultMapLatitude = 50.4501
internal const val DefaultMapLongitude = 30.5234
internal const val DefaultMapZoom = 12.0
internal const val SelectedMarkerZoom = 15.0
